module.exports = __webpack_public_path__ + "static/media/salad.9b1c3886.svg";